<template>
  <div>
    <div class="boss-layout boss-layout-vertical">
      <div>
        <Accordion :is-open="true">
          <template #head>
            よく使う項目
          </template>
          <template #body>
            <div class="boss-table-2">
              <scout-form-age v-model="searchData.parameter.age" />
              <scout-form-gender v-model="searchData.parameter.gender" />
              <scout-form-prefecture
                v-if="!create || isSetDefaultSearchConditionParam"
                :prefectures.sync="searchData.parameter.address.prefectures"
                :cities.sync="searchData.parameter.address.cities"
                :selected-option.sync="searchData.parameter.address.selectedOption"
                :contain-work-prefectures-non-hope-user.sync="searchData.parameter.address.containNonHopeUser"
                :show-annotation-label="true"
              />
              <scout-form-educational-background
                v-model="searchData.parameter.educationalBackground"
                :from.sync="searchData.parameter.graduatedSchool.year.from"
                :to.sync="searchData.parameter.graduatedSchool.year.to"
                :dept-codes.sync="searchData.parameter.graduatedSchool.deptCodes"
                :free-word.sync="searchData.condition.graduatedSchoolKeyword"
                :operator.sync="searchData.parameter.graduatedSchool.operator"
                :free-word-error-message="freeWordValidationError.graduatedSchoolKeyword"
              />
              <scout-form-changed-jobs v-model="searchData.parameter.changeOverJobsCount.maximum" />
              <scout-form-employed v-model="searchData.parameter.employed" />
              <scout-form-annual-salary
                v-bind.sync="searchData.parameter.annualSalary"
                prefix="直近の"
              />
              <scout-form-occupation
                :experienced-occupations.sync="searchData.parameter.occupations.experienced"
                :desired-occupations.sync="searchData.parameter.occupations.desired"
                :selected-option.sync="searchData.parameter.occupations.operator"
                :contain-occupations-non-hope-user.sync="searchData.parameter.occupations.containNonHopeUser"
              />
              <scout-form-business
                :experienced-businesses.sync="searchData.parameter.businesses.experienced"
                :desired-businesses.sync="searchData.parameter.businesses.desired"
                :selected-option.sync="searchData.parameter.businesses.operator"
                :contain-businesses-non-hope-user.sync="searchData.parameter.businesses.containNonHopeUser"
              />
              <scout-form-skill
                v-model="searchData.parameter.skills.conditions"
                :selected-option.sync="searchData.parameter.skills.operator"
              />
              <scout-form-license
                v-model="searchData.parameter.licenses.ids"
                :selected-option.sync="searchData.parameter.licenses.operator"
              />
              <scout-form-targeting :is-review-saved.sync="searchData.parameter.isReviewSaved" />
              <scout-form-active-recent v-model.number="searchData.parameter.activeRecent" />
              <scout-form-others :has-career-resumes.sync="searchData.parameter.hasCareerResumes" />
            </div>
          </template>
        </Accordion>
      </div>
      <!-- さらに詳しい条件設定 -->
      <div>
        <Accordion :is-open="false">
          <template #head>
            さらに詳しい条件設定
          </template>
          <template #body>
            <div class="boss-table-2">
              <scout-form-language-skill
                :toeic.sync="searchData.parameter.toeicScore.minimum"
                :toefl.sync="searchData.parameter.toeflScore.minimum"
                :language-skills.sync="searchData.parameter.languageSkills"
              />
              <scout-form-free-word
                v-model="searchData.condition.freeWord"
                :exclude-word.sync="searchData.condition.excludeWord"
                :operator.sync="searchData.parameter.freeWord.operator"
                :free-word-error-message="freeWordValidationError.freeWord"
                :exclude-word-error-message="freeWordValidationError.excludeWord"
              />
              <scout-form-employment-types
                v-model="searchData.parameter.employmentTypes"
                prefix="直近の"
              />
              <scout-form-employment-types
                v-model="searchData.parameter.desiredEmploymentTypes"
                prefix="希望の"
              />
              <scout-form-other-company-scouts v-model.number="searchData.parameter.excludedApproachedScout.otherCompany.maximum" />
              <scout-form-boolean-pulldown
                v-model="searchData.parameter.married"
                label="未既婚"
                :options="definition.married"
              />
              <scout-form-boolean-pulldown
                v-model="searchData.parameter.hasChild"
                label="子供有無"
                :options="definition.childStatus"
              />
              <scout-form-boolean-pulldown
                v-model="searchData.parameter.canHomeMoving"
                label="転居を伴う転職可否"
                :options="definition.homeMovingStatus"
              />
              <scout-form-work-style
                :work-styles.sync="searchData.parameter.workStyles.conditions"
                :selected-option.sync="searchData.parameter.workStyles.operator"
              />
              <scout-form-registration-date
                :from.sync="searchData.condition.registrationDate_from"
                :to.sync="searchData.condition.registrationDate_to"
                :selected-option.sync="searchData.condition.selectedRegistrationDateValue"
              />
              <scout-form-resume-update-date
                :from.sync="searchData.condition.resumeUpdateDate_from"
                :to.sync="searchData.condition.resumeUpdateDate_to"
                :selected-option.sync="searchData.condition.selectedResumeUpdateDateValue"
              />
              <scout-form-active-date v-bind.sync="searchData.parameter.activeDate" />
              <scout-form-exclude
                :scout-this-job-option.sync="searchData.condition.selectedApproachedThisJobOptionValue"
                :scout-this-job-from.sync="searchData.condition.approachedThisJob_from"
                :scout-this-job-to.sync="searchData.condition.approachedThisJob_to"
                :scout-other-job-option.sync="searchData.condition.selectedApproachedOtherJobOptionValue"
                :scout-other-job-from.sync="searchData.condition.approachedOtherJob_from"
                :scout-other-job-to.sync="searchData.condition.approachedOtherJob_to"
                :applies-other-company.sync="searchData.parameter.excludeEntryOtherCompanyJob"
                :has-candidate-other-job.sync="searchData.parameter.excludedCandidateOtherJob"
              />
              <scout-form-member-id
                v-model="searchData.parameter.userId"
                explanation="会員IDを入力した場合は他の検索条件は無効となります。"
              />
            </div>
          </template>
        </Accordion>
        <form-button-area>
          <form-back-button
            data-test="back-button"
            @back="back"
          />
        </form-button-area>
      </div>
      <!-- さらに詳しい条件設定 -->
    </div>
    <scout-search-trigger-container
      :search-count="searchCount"
      :is-searching="isSearching"
      :search-condition-id="Number(searchData.id)"
      :condition-name="searchData.name"
      :is-error="isError"
      @search="searchResults"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { SearchDataModel } from '@/model/searchDataModel'
import Accordion from '@/components/atoms/Accordion'
import ScoutFormActiveDate from '@/components/atoms/ScoutFormActiveDate'
import ScoutFormActiveRecent from '@/components/atoms/ScoutFormActiveRecent'
import ScoutFormAge from '@/components/atoms/ScoutFormAge'
import ScoutFormAnnualSalary from '@/components/atoms/ScoutFormAnnualSalary'
import ScoutFormBooleanPulldown from '@/components/atoms/ScoutFormBooleanPulldown'
import ScoutFormChangedJobs from '@/components/atoms/ScoutFormChangedJobs'
import ScoutFormEducationalBackground from '@/components/atoms/ScoutFormEducationalBackground'
import ScoutFormEmployed from '@/components/atoms/ScoutFormEmployed'
import ScoutFormEmploymentTypes from '@/components/atoms/ScoutFormEmploymentTypes'
import ScoutFormExclude from '@/components/atoms/ScoutFormExclude'
import ScoutFormFreeWord from '@/components/atoms/ScoutFormFreeWord'
import ScoutFormGender from '@/components/atoms/ScoutFormGender'
import ScoutFormLanguageSkill from '@/components/atoms/ScoutFormLanguageSkill'
import ScoutFormLicense from '@/components/atoms/ScoutFormLicense'
import ScoutFormMemberId from '@/components/atoms/ScoutFormMemberId'
import ScoutFormOccupation from '@/components/atoms/ScoutFormOccupation'
import ScoutFormOtherCompanyScouts from '@/components/atoms/ScoutFormOtherCompanyScouts'
import ScoutFormOthers from '@/components/atoms/ScoutFormOthers'
import ScoutFormPrefecture from '@/components/atoms/ScoutFormPrefecture'
import ScoutFormRegistrationDate from '@/components/atoms/ScoutFormRegistrationDate'
import ScoutFormResumeUpdateDate from '@/components/atoms/ScoutFormResumeUpdateDate'
import ScoutFormBusiness from '@/components/atoms/ScoutFormBusiness'
import ScoutFormSkill from '@/components/atoms/ScoutFormSkill'
import ScoutFormWorkStyle from '@/components/atoms/ScoutFormWorkStyle'
import ScoutFormTargeting from '@/components/atoms/ScoutFormTargeting'
import FormButtonArea from '@/components/atoms/FormButtonArea'
import FormBackButton from '@/components/atoms/FormBackButton'
import ScoutSearchTriggerContainer from '@/components/molecules/ScoutSearchTriggerContainer'
import Indicator from '@/lib/indicator'
import * as definition from '@/lib/labelValueMappings'

export default {
  components: {
    Accordion,
    ScoutFormActiveDate,
    ScoutFormActiveRecent,
    ScoutFormAge,
    ScoutFormAnnualSalary,
    ScoutFormBooleanPulldown,
    ScoutFormChangedJobs,
    ScoutFormEducationalBackground,
    ScoutFormEmployed,
    ScoutFormEmploymentTypes,
    ScoutFormExclude,
    ScoutFormFreeWord,
    ScoutFormGender,
    ScoutFormLanguageSkill,
    ScoutFormLicense,
    ScoutFormMemberId,
    ScoutFormOccupation,
    ScoutFormOtherCompanyScouts,
    ScoutFormOthers,
    ScoutFormPrefecture,
    ScoutFormRegistrationDate,
    ScoutFormResumeUpdateDate,
    ScoutFormBusiness,
    ScoutFormSkill,
    ScoutFormWorkStyle,
    ScoutFormTargeting,
    FormButtonArea,
    FormBackButton,
    ScoutSearchTriggerContainer
  },
  props: {
    create: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchCount: null,
      searchData: new SearchDataModel(),
      isError: true,
      freeWordValidationError: {
        graduatedSchoolKeyword: '',
        freeWord: '',
        excludeWord: ''
      },
      isSetDefaultSearchConditionParam: false,
      defaultSearchConditionParam: new SearchDataModel().parameter,
      noDataSearchConditionParam: new SearchDataModel().parameter,
      isEmptyChange: false,
      isSearching: false,
      definition: definition,
      // isEmptyChangeで検索の抑制をしているが、保存した検索条件編集からの遷移で検索されないパターンがあるため追加
      // operatorがある項目かつその項目の条件を未指定の場合がある場合に初回検索が走らない
      // 例
      // 1.職種 すべて合致 条件指定あり
      // 2.業種 いずれか合致 条件指定なし
      // の場合に発生
      isFirstSearched: false
    }
  },
  computed: {
    ...mapGetters({
      membersSearchConditionByJobId: 'membersSearchCondition'
    }),
    membersSearchCondition () {
      return this.membersSearchConditionByJobId(this.$route.params.jobId)
    },
    isDefaultSearchConditionParam () {
      return _.isEqual(this.searchData.parameter, this.defaultSearchConditionParam)
    },
    isNoDataSearchConditionParam () {
      return _.isEqual(this.searchData.parameter, this.noDataSearchConditionParam)
    },
    isSkipFetch () {
      return this.isDefaultSearchConditionParam ||
      this.isNoDataSearchConditionParam ||
      (this.isEmptyChange && this.isFirstSearched) ||
      this.isFreeWordError
    },
    isFreeWordError () {
      return !!this.freeWordValidationError.graduatedSchoolKeyword ||
      !!this.freeWordValidationError.freeWord ||
      !!this.freeWordValidationError.excludeWord
    }
  },
  watch: {
    'searchData.condition.graduatedSchoolKeyword' (val) {
      this.$set(this.freeWordValidationError, 'graduatedSchoolKeyword', this.setKeywordsFromConditionToParameter(val, 'graduatedSchool'))
    },
    'searchData.condition.freeWord' (val) {
      this.$set(this.freeWordValidationError, 'freeWord', this.setKeywordsFromConditionToParameter(val, 'freeWord'))
    },
    'searchData.condition.excludeWord' (val) {
      this.$set(this.freeWordValidationError, 'excludeWord', this.setKeywordsFromConditionToParameter(val, 'excludeWord'))
    },
    // 最終ログインのバインド
    'searchData.condition.selectedRegistrationDateValue' (val) {
      this.$set(this.searchData.parameter.registrationDate, 'selectedDateTimeWithinDays', this.getWithinDaysFromTerms(val))
      if (_.get(val, 'terms', '') === '') {
        this.$set(this.searchData.parameter.registrationDate, 'selectedDateTimeRangeForm', null)
      }
    },
    // NOTE: selectedDateTimeRangeForm内のプロパティは、optionId: ''の時にnullにしてほしいバックエンドの要望があるため、直接バインドできない
    'searchData.condition.registrationDate_from' (val) {
      if (this.searchData.condition.selectedRegistrationDateValue.id !== '') {
        _.set(this.searchData.parameter, 'registrationDate.selectedDateTimeRangeForm.from', val)
      }
    },
    'searchData.condition.registrationDate_to' (val) {
      if (this.searchData.condition.selectedRegistrationDateValue.id !== '') {
        _.set(this.searchData.parameter, 'registrationDate.selectedDateTimeRangeForm.to', val)
      }
    },
    // レジュメ更新日のバインド
    'searchData.condition.selectedResumeUpdateDateValue' (val) {
      this.$set(this.searchData.parameter.resumeUpdateDate, 'selectedDateTimeWithinDays', this.getWithinDaysFromTerms(val))
      if (_.get(val, 'terms', '') === '') {
        this.$set(this.searchData.parameter.resumeUpdateDate, 'selectedDateTimeRangeForm', null)
      }
    },
    'searchData.condition.resumeUpdateDate_from' (val) {
      if (this.searchData.condition.selectedResumeUpdateDateValue.id !== '') {
        _.set(this.searchData.parameter, 'resumeUpdateDate.selectedDateTimeRangeForm.from', val)
      }
    },
    'searchData.condition.resumeUpdateDate_to' (val) {
      if (this.searchData.condition.selectedResumeUpdateDateValue.id !== '') {
        _.set(this.searchData.parameter, 'resumeUpdateDate.selectedDateTimeRangeForm.to', val)
      }
    },
    'searchData.condition.selectedApproachedThisJobOptionValue' (val) {
      this.$set(this.searchData.parameter.excludedApproachedScout.ownCompany.thisJob, 'selectedDateTimeWithinDays', this.getWithinDaysFromTerms(val))
      if (_.get(val, 'terms', '') === '') {
        this.$set(this.searchData.parameter.excludedApproachedScout.ownCompany.thisJob, 'selectedDateTimeRangeForm', null)
      }
    },
    'searchData.condition.approachedThisJob_from' (val) {
      if (this.searchData.condition.selectedApproachedThisJobOptionValue.id !== '') {
        _.set(this.searchData.parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.from', val)
      }
    },
    'searchData.condition.approachedThisJob_to' (val) {
      if (this.searchData.condition.selectedApproachedThisJobOptionValue.id !== '') {
        _.set(this.searchData.parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.to', val)
      }
    },
    'searchData.condition.selectedApproachedOtherJobOptionValue' (val) {
      this.$set(this.searchData.parameter.excludedApproachedScout.ownCompany.otherJob, 'selectedDateTimeWithinDays', this.getWithinDaysFromTerms(val))
      if (_.get(val, 'terms', '') === '') {
        this.$set(this.searchData.parameter.excludedApproachedScout.ownCompany.otherJob, 'selectedDateTimeRangeForm', null)
      }
    },
    'searchData.condition.approachedOtherJob_from' (val) {
      if (this.searchData.condition.selectedApproachedOtherJobOptionValue.id !== '') {
        _.set(this.searchData.parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.from', val)
      }
    },
    'searchData.condition.approachedOtherJob_to' (val) {
      if (this.searchData.condition.selectedApproachedOtherJobOptionValue.id !== '') {
        _.set(this.searchData.parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.to', val)
      }
    },
    'searchData.parameter.graduatedSchool.operator' () {
      this.checkChangeEmpty('condition.graduatedSchoolKeyword')
    },
    'searchData.parameter.address.selectedOption' () {
      this.updateIsEmptyChangeForNoDataPaths(['parameter.address.prefectures', 'parameter.address.cities'])
    },
    'searchData.parameter.address.containNonHopeUser' () {
      this.updateIsEmptyChangeForNoDataPaths(['parameter.address.prefectures', 'parameter.address.cities'])
    },
    'searchData.parameter.occupations.containNonHopeUser' () {
      this.checkChangeEmpty('parameter.occupations.desired')
    },
    'searchData.parameter.occupations.operator' () {
      this.updateIsEmptyChangeForNoDataPaths(['parameter.occupations.experienced', 'parameter.occupations.desired'])
    },
    'searchData.parameter.businesses.containNonHopeUser' () {
      this.checkChangeEmpty('parameter.businesses.desired')
    },
    'searchData.parameter.businesses.operator' () {
      this.updateIsEmptyChangeForNoDataPaths(['parameter.businesses.experienced', 'parameter.businesses.desired'])
    },
    'searchData.parameter.skills.operator' () {
      this.checkChangeEmpty('parameter.skills.conditions')
    },
    'searchData.parameter.licenses.operator' () {
      this.checkChangeEmpty('parameter.licenses.ids')
    },
    'searchData.parameter.freeWord.operator' () {
      this.checkChangeEmpty('condition.freeWord')
    },
    'searchData.parameter.excludeWord.operator' () {
      this.checkChangeEmpty('condition.excludeWord')
    },
    'searchData.parameter.workStyles.operator' () {
      this.checkChangeEmpty('parameter.workStyles.conditions')
    },
    $route: {
      handler: 'fetchMembersCount'
    },
    searchData: {
      handler () {
        this.debouncedFetchMembersCount()
      },
      deep: true
    }
  },
  created () {
    const masters = [
      'genders',
      'educationalBackgrounds',
      'educationalDepartments',
      'prefectures',
      'occupations',
      'businesses',
      'languageSkills',
      'languages',
      'skills',
      'licenses',
      'workStyles',
      'employmentStatuses'
    ]
    masters.forEach(element => {
      this.storeMaster(element)
    })
    this.debouncedFetchMembersCount = _.debounce(this.fetchMembersCount, 500)
    if (!this.create) {
      this.$set(this, 'searchData', _.cloneDeep(this.membersSearchCondition))
      if (!this.searchData.parameter.age.minimum) {
        this.searchData.parameter.age.minimum = 18
      }
      if (!this.searchData.parameter.age.maximum) {
        this.searchData.parameter.age.maximum = 65
      }
    } else {
      this.$http.secured.get(`/scout/view/scouts/jobs/${this.$route.params.jobId}/default_search_conditions`)
        .then(response => {
          // デフォルト値指定：都道府県
          const workPrefectureIds = response.data.workPrefectureIds
          this.$set(this.searchData.parameter.address, 'prefectures', workPrefectureIds)
          // デフォルト検索条件を保持
          this.defaultSearchConditionParam = _.cloneDeep(this.searchData.parameter)
        }).catch(() => {
          /* NOP */
        }).finally(() => {
          this.isSetDefaultSearchConditionParam = true
        })
    }
    Indicator.emitHide()
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ]),
    searchResults (searchConditionName) {
      this.$set(this.searchData, 'name', searchConditionName)
      this.upsertSearchConditionIfNeed(this.searchData).then(() => {
        this.goResults()
      })
    },
    async upsertSearchConditionIfNeed (condition) {
      const parameter = this.createAPIParameter()
      const request = {
        parameter: parameter,
        condition: JSON.stringify(condition.condition),
        name: condition.name
      }
      if (condition.id) {
        await this.$http.secured.put(`/scout/view/scouts/search_conditions/${condition.id}`, request)
      } else if (condition.name) {
        const response = await this.$http.secured.post(`scout/view/scouts/jobs/${this.$route.params.jobId}/search_conditions`, request)
          .catch(error => { throw error })
        condition.id = response.data
      }
      const membersSearchCondition = {
        id: condition.id,
        name: condition.name,
        parameter: parameter,
        condition: condition.condition
      }
      this.$store.dispatch('setMembersSearchCondition', { jobId: this.$route.params.jobId, membersSearchCondition: membersSearchCondition })
    },
    fetchMembersCount () {
      if (!this.isSkipFetch) {
        this.$set(this, 'isFirstSearched', true)
        const apiParameter = this.createAPIParameter()
        this.$set(this, 'isSearching', true)
        this.$http.secured.post(`scout/view/contracts/${this.$route.params.contractId}/jobs/${this.$route.params.jobId}/users/_search/_count`, apiParameter).then(response => {
          if (_.isEqual(JSON.parse(response.config.data), this.createAPIParameter())) {
            this.$set(this, 'isError', false)
            this.$set(this, 'searchCount', response.data)
            this.$set(this, 'isSearching', false)
          }
        }).catch((error) => {
          // 現在の検索条件とAPIで投げた検索条件が一致している場合
          if (_.isEqual(JSON.parse(error.response.config.data), this.createAPIParameter())) {
            this.$set(this, 'isError', true)
            this.$set(this, 'isSearching', false)
          }
        })
      }
      this.isEmptyChange = false // 空更新フラグの初期化
    },
    createAPIParameter () {
      const storeParameter = _.cloneDeep(this.searchData.parameter)
      const apiParameter = { ...storeParameter }
      if (apiParameter.skills && apiParameter.skills.conditions.length) {
        apiParameter.skills.conditions = apiParameter.skills.conditions.filter(condition => condition.years.minimum !== '')
      }
      if (apiParameter.languageSkills.length) {
        apiParameter.languageSkills = apiParameter.languageSkills.filter(languageSkill => languageSkill.id !== '' && languageSkill.level !== '')
      }
      if (apiParameter.workStyles.conditions.length) {
        apiParameter.workStyles.conditions = apiParameter.workStyles.conditions.filter(condition => condition.answer)
      }
      return apiParameter
    },
    setKeywordsFromConditionToParameter (val, path) {
      const keywords = val.trim()
      if (keywords) {
        this.$set(this.searchData.parameter[path], 'keywords', (_.uniq(keywords.split(/\s+/g))))
        if (this.searchData.parameter[path].keywords.length > 20) {
          this.$set(this, 'isError', true)
          return 'キーワードの数は20語以内にして下さい。'
        } else if (this.searchData.parameter[path].keywords.some(keyword => keyword.length > 20)) {
          this.$set(this, 'isError', true)
          return '1つのキーワードは20文字以内にして下さい。'
        }
      } else {
        this.$set(this.searchData.parameter[path], 'keywords', ([]))
      }
      return ''
    },
    getWithinDaysFromTerms (val) {
      // selectedDateTime系の日数を取得する
      const terms = _.get(val, 'terms', '')
      if (terms === '' || terms === 'select') {
        // 初期値 / 未指定 / 日時指定の場合は、日数はnullで返却
        return null
      } else {
        return terms
      }
    },
    checkChangeEmpty (path) {
      // 設定値がない場合は検索が走らないよう抑制
      this.isEmptyChange = _.get(this.searchData, path, []).length === 0
    },
    updateIsEmptyChangeForNoDataPaths (paths = []) {
      // 複数項目に関係がある設定値がない場合は検索が走らないよう抑制
      this.isEmptyChange = !paths.some(path => _.get(this.searchData, path, []).length !== 0)
    },
    back () {
      this.$router.back()
    },
    goResults () {
      this.$router.push(`/scouts/contracts/${this.$route.params.contractId}/jobs/${this.$route.params.jobId}/users/search_results`)
    }
  }
}
</script>
